(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mypadl-labor-day-2026"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const card = document.getElementById('mypadl-ld26');
    if (!card || card.dataset.ready) return;
    card.dataset.ready = 'true';
    const ends = Date.parse('2026-09-08T01:00:00-07:00');
    const key = 'mypadl:ld26:seen';
    const preview = Boolean(window.Shopify && window.Shopify.designMode);
    const seen = () => {
      try { return localStorage.getItem(key) === '1'; }
      catch { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } }
    };
    const remember = () => {
      try { localStorage.setItem(key, '1'); }
      catch { try { sessionStorage.setItem(key, '1'); } catch {} }
    };
    if (Date.now() >= ends || (!preview && seen())) return;
    let timer;
    let stopped = false;
    let shown = false;
    const close = () => { stopped = true; card.hidden = true; clearTimeout(timer); remember(); };
    card.querySelector('.ld26-close').addEventListener('click', close);
    card.querySelector('.ld26-cta').addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !card.hidden) close(); });
    document.addEventListener('submit', e => {
      if (e.target.action && e.target.action.includes('/cart')) close();
    }, true);
    document.addEventListener('focusin', e => {
      if (!card.contains(e.target) && e.target.matches('input,select,textarea,[contenteditable="true"]')) {
        if (shown) close();
        else { stopped = true; clearTimeout(timer); }
      }
    });
    const visibleOverlay = element => {
      if (element.closest('[hidden], [aria-hidden="true"], details:not([open])')) return false;
      if (element.checkVisibility) return element.checkVisibility({checkOpacity:true, checkVisibilityCSS:true});
      return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    };
    const blocked = () => document.hidden ||
      Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, header details[open]')).some(visibleOverlay) ||
      document.activeElement?.matches('input,select,textarea,[contenteditable="true"]');
    const show = () => {
      if (stopped || Date.now() >= ends || (!preview && seen())) return;
      if (blocked()) { timer = setTimeout(show, 2000); return; }
      shown = true;
      card.hidden = false;
      if (!preview) remember();
      setTimeout(close, Math.max(0, ends - Date.now()));
    };
    timer = setTimeout(show, preview ? 500 : matchMedia('(max-width:600px)').matches ? 12000 : 8000);
    document.addEventListener('visibilitychange', () => { if (Date.now() >= ends) close(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
